<template>
  <div>
    <div
      @click="
        () => {
          nextStep(e);
        }
      "
      class="MyLoadList"
      v-for="e in list"
      :key="e.orderId"
    >
      <div class="MyLoadList_head">
        <div class="MyLoadList-logo">
          <img :src="e.pcLogoUrl" alt="" />
          <div style="font-size:16px">{{ e.productName }}</div>
          <div class="tag" v-if="e.aggsProductName">{{ e.aggsProductName }}</div>
        </div>
        <div class="statusDesc">{{e.statusDesc}}</div>
      </div>
      <div class="MyLoadList_line"></div>
      <div class="MyLoadList_content">
        <div>
          <div class="MyLoadList_content_title">申请金额(元)</div>
          <div class="MyLoadList_content_text">{{ e.loanAmount !== 'null' ? e.loanAmount : '--'}}</div>
        </div>
        <div>
          <div class="MyLoadList_content_title">贷款期限</div>
          <div class="MyLoadList_content_text">{{ e.term || '--' }}</div>
        </div>
        <div>
          <div class="MyLoadList_content_title">申请时间</div>
          <div class="MyLoadList_content_text">{{ e.orderTime || '--' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyLoadList',
  data() {
    return {
      listText: [],
      step: [],
    };
  },
  props: ['list'],
  methods: {
    nextStep(e) {
      const { status, orderId, productId } = e;
      const str = `?orderId=${orderId}&productId=${productId}`;
      localStorage.setItem('productid', productId);
      this.jumpPage(status, orderId, productId, str);
    },
    jumpPage(status, orderId) {
      if (status) {
        if (orderId !== 'null') {
          localStorage.setItem(orderId, orderId);
          localStorage.setItem('orderId', orderId);
        }
      } else {
        localStorage.removeItem('orderId');
      }
      this.jumpTheThirdPartyAddress(orderId);
    },
    jumpTheThirdPartyAddress(orderId) {
      this.$api.PublicPage.jumpCurrPage({
        orderId,
      })
        .then((res) => {
          if (res.success) {
            if (res.data) {
              window.location.href = res.data;
            }
          } else {
            this.$dialog.alert({
              title: '提示',
              message: '操作失败',
            });
          }
        })
        .catch((e) => {
          this.$dialog.alert({
            title: '提示',
            message: e,
          });
        });
    },
  },
};
</script>
<style scoped>
.MyLoadList {
  height: 129px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  margin-top: 10px;
}
.MyLoadList_head img {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin: 0 8px;
  border: 1px solid #ececec;
}
.MyLoadList-logo{
  display: flex;
  align-items: center;
}
.tag{
  color: #ff6538;
  font-size: 12px;
  padding: 2px;
  background-color: rgba(255, 101, 56, .1);
  margin-left: 8px;
}
.statusDesc{
  font-size: 13px;
  color: red;
  margin-top: 8px;
}
.MyLoadList_head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding: 0 15px;
}
.MyLoadList_line {
  width: 100%;
  height: 1px;
  background: #eee;
}
.MyLoadList_content {
  width: 100%;
  height: 73px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.MyLoadList_content_title {
  font-size: 12px;
  color: #b7bfd2;
}
.MyLoadList_content_text {
  font-size: 13px;
  color: #000;
  margin-top: 8px;
}
</style>
